import React from 'react'
import PropTypes from 'prop-types'
import TravelerSelection from '@pcln/traveler-selection'

const ChangeSearchPassengers = ({
  passengers,
  setPassengers,
  isWhiteLabel,
  isReshopExperience,
  subLabelMap,
  lapInfantLabel
}) => (
  <TravelerSelection
    height={46}
    initialValues={passengers}
    onChange={setPassengers}
    isWhiteLabel={isWhiteLabel}
    trapFocus={false}
    isTravelerSelectionDisabled={isReshopExperience}
    borderRadius='lg'
    subLabelMap={subLabelMap}
    lapInfantLabel={lapInfantLabel}
  />
)

ChangeSearchPassengers.propTypes = {
  passengers: PropTypes.object,
  setPassengers: PropTypes.func,
  isWhiteLabel: PropTypes.bool,
  isReshopExperience: PropTypes.bool,
  subLabelMap: PropTypes.objectOf({
    adults: PropTypes.string,
    youths: PropTypes.string,
    children: PropTypes.string,
    lapInfants: PropTypes.string,
  }),
  lapInfantLabel: PropTypes.string,
}

export { ChangeSearchPassengers }
